<template>
  <div class="privacy-page">
    <div class="card">
      <h2>用户隐私保护指引</h2>

      <div class="section">
        <h3>一、我们收集的信息</h3>
        <p>1. 摄像头权限：用于拍照签到及登记学员对照照。</p>
        <p>2. 学员对照照片：由机构登记并存于机构服务器，作为签到比对基准。签到时拍摄的现场照片仅用于当次比对，完成后立即删除，不保存到本机，也不进行实名人脸核身。</p>
        <p>3. 学生及家长信息：姓名、手机号、课时记录等，用于培训管理。</p>
      </div>
      <div class="section">
        <h3>二、信息的使用</h3>
        <p>收集的信息仅用于乒乓球培训的课时管理、签到记录及家长查询，不会向第三方出售或共享。</p>
      </div>
      <div class="section">
        <h3>三、信息的存储与保护</h3>
        <p>我们采取合理的技术措施保护您的个人信息安全。人脸数据加密存储，仅授权管理员可访问。</p>
      </div>
      <div class="section">
        <h3>四、您的权利</h3>
        <p>您有权查询、更正或删除您及孩子的相关信息，请联系所在培训机构处理。</p>
      </div>

      <router-link to="/" class="link back">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default { name: 'Privacy' }
</script>

<style scoped>
.privacy-page { max-width: 640px; margin: 0 auto; padding: 16px; min-height: 100vh; background: #f5f5f5; }
.card { background: #fff; border-radius: 12px; padding: 24px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
h2 { margin-bottom: 16px; }
.section { margin-bottom: 20px; }
.section h3 { font-size: 15px; margin-bottom: 8px; color: #333; }
.section p { color: #666; font-size: 14px; line-height: 1.6; margin-bottom: 8px; }
.link { display: block; color: #409EFF; font-size: 14px; margin-top: 16px; text-decoration: none; }
</style>
